import { Platform, Text, View, Dimensions } from 'react-native';
import { connect } from 'react-redux';
import WidgetList from './WidgetList';
import { useEffect } from 'react';
import * as Animatable from 'react-native-animatable';
import React from 'react';

import { useDeviceType } from '@hooks/useDeviceType';
import { useReactiveWindowDimensions } from '@hooks/useReactiveWindowDimensions';

function ActiveWidget(widgetStatus) {
  let { activeWidget } = widgetStatus;

  // Use reactive window dimensions that update on fold/unfold
  const { width: windowWidth } = useReactiveWindowDimensions();
  const [availableWidth, setAvailableWidth] = React.useState(
    Platform.OS !== 'web' ? windowWidth : (typeof window !== 'undefined' ? window.innerWidth : 0)
  );
  const { isTablet } = useDeviceType();
  const listedWidgets = WidgetList;
  const item = listedWidgets.filter(item => item.id === activeWidget.activeWidget?.id);

  let Widget;
  try {
    if (activeWidget && item[0]?.widget) {
      Widget = React.cloneElement(item[0]?.widget, { availableWidth });
    } else {
      Widget = undefined;
    }
  } catch (error) {
    Widget = undefined;
  }

  // Update availableWidth when window dimensions change (for fold/unfold)
  useEffect(() => {
    if (Platform.OS !== 'web') {
      const prevWidth = availableWidth;
      setAvailableWidth(windowWidth);
      if (prevWidth !== windowWidth && prevWidth > 0) {
        console.warn('📐 [ActiveWidgetComponent] Window width change:', {
          prev: prevWidth,
          new: windowWidth,
          delta: windowWidth - prevWidth,
          source: 'useReactiveWindowDimensions'
        });
      }
    }
  }, [windowWidth, availableWidth]);

  // Listen to dimension changes as additional fallback
  useEffect(() => {
    const subscription = Dimensions.addEventListener('change', ({ window }) => {
      if (Platform.OS !== 'web') {
        const prevWidth = availableWidth;
        setAvailableWidth(window.width);
        if (prevWidth !== window.width && prevWidth > 0) {
          console.warn('📐 [ActiveWidgetComponent] Dimension change (event listener):', {
            prev: prevWidth,
            new: window.width,
            delta: window.width - prevWidth,
            dimensions: { width: window.width, height: window.height },
            source: 'Dimensions.addEventListener'
          });
        }
      }
    });

    return () => {
      subscription?.remove();
    };
  }, [availableWidth]);

  // Web-specific resize listener
  useEffect(() => {
    if (Platform.OS === 'web' && typeof window !== 'undefined') {
      const handleResize = () => {
        setAvailableWidth(window.innerWidth);
      };
      window.addEventListener('resize', handleResize);
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }
  }, []);

  return activeWidget ? (
    <View style={{ flex: 1, minHeight: Platform.OS != 'web' ? '95%' : undefined, flexGrow: 3, flexWrap: 'wrap', alignSelf: 'stretch', overflow: 'visible' }} onLayout={({ nativeEvent }) => {
      setAvailableWidth(nativeEvent.layout.width);
    }} >
      {
        activeWidget.state ?
          <Animatable.View useNativeDriver key={activeWidget} animation={'fadeIn'} style={{ flexGrow: 10, minWidth: "100%", flex: 1, alignSelf: 'stretch' }}>
            {
              Widget ? Widget : <Text>Widget not found</Text>
            }
          </Animatable.View>
          :
          <View>
            <Text adjustsFontSizeToFit >No widget</Text>
          </View>
      }
    </View>
  ) :
    (<Text>No widget selected</Text>)
}

const mapStateToProps = function (state) {
  return {
    activeWidget: state.widgets
  }
}
export default connect(mapStateToProps)(ActiveWidget);